import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-metabrainz', 'BrandMetabrainz', [["path",{"d":"M3 7v10l7 4v-18l-7 4"}],["path",{"d":"M21 7v10l-7 4v-18l7 4"}]]);